import { APP_FONT_CSS_VAR, DEFAULT_FONT_STACK } from './app-fonts.constants';

/**
 * The default font stack, used by charts (plotly/echarts) where the CSS
 * `font-family` cascade does not apply (canvas/SVG text rendering).
 *
 * `family` is a getter so it resolves the *current* tenant font at access
 * time — every `{ ...FONT_FAMILY }` spread therefore picks up the font set on
 * the `--app-font-family` custom property. It reads `getComputedStyle` only on
 * access (chart render), never at import, and falls back to the default stack
 * when the DOM/var is not yet available.
 */
export const FONT_FAMILY = Object.freeze({
	get family(): string {
		if (typeof document !== 'undefined' && document.documentElement) {
			const value = getComputedStyle(document.documentElement)
				.getPropertyValue(APP_FONT_CSS_VAR)
				.trim();
			if (value) {
				return value;
			}
		}
		return DEFAULT_FONT_STACK;
	}
});
